<template>
  <div class="videorank">
    <sub-title :text="title" />
    <div class="list" >
      <div class="item flex_start" v-for="item in num" :key="item">
        <div class="videorank_cover">
          <img src="~assets/telzx/aaaa1_sample.png" alt="" />
        </div>
        <div class="videorank_det">
          <div class="flex_start">
            <div class="FontSize18 name">XX律师</div>
            <div class="FontSize12 tag">婚姻家庭</div>
          </div>
          <div class="btm between">
            <div class="adr FontSize12 center">
              <img src="~assets/claim/dingwei.png" alt="" />
              四川-成都
            </div>
            <div class="seenum FontSize14"><span>168250</span> 次看过</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import subTitle from "../../home/components/subTitle";
export default {
  components: {
    subTitle,
  },
  props:{
      title:String,
      num:Number
  }
};
</script>

<style lang="scss" scoped>
.videorank {
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.05);
  padding: 24px 20px;
  .list {
    .item {
        margin-top:28px;
        cursor: pointer;
      .videorank_cover {
        margin-right: 12px;
        img {
          width: 74px;
          height: 74px;
          border-radius: 50%;
        }
      }
      .videorank_det {
        color: #333333;
        width: 100%;
        
        .tag {
          font-size: 12px;
          border: 1px solid #8c8c8c;
          padding: 1px 4px;
          margin-left: 15px;
        }
        .btm {
          width: 100%;
    margin-top: 12px;

          .adr {
            img {
              width: 10px;
              height: 12px;
              margin-right: 6px;
            }
          }
          .seenum{
              span{color:#DA0B0B}
          }
        }
      }

      &:hover{
          .videorank_det .name {
              color: #0465EA;
        }
      }
    }
  }
}
</style>